import axios from './axios';
import { useAuth } from './useAuth';

const useRefreshToken = () => {
  const { auth, setAuth } = useAuth() as any;

  const refresh = async () => {
    const bodyFormData = new URLSearchParams();
    bodyFormData.append('refresh_token', auth?.refreshToken);
    const response = await axios.post('/refresh',
      bodyFormData,
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
    );
    setAuth((prev: any) => {
      return { ...prev, accessToken: response.data.data.accessToken, refreshToken: response.data.data.refreshToken };
    });
    return response.data.data;
  };
  return refresh;
};

export default useRefreshToken;
